import styled from "@emotion/styled";
import { Col, Container, Row } from "react-bootstrap";

const Main = styled.main`
  flex-grow: 1;
`;

const MainContent = ({ children }: { children: React.ReactNode }) => (
  <Main>
    <Container>
      <Row>
        <Col xs={12}>{children}</Col>
      </Row>
    </Container>
  </Main>
);

export default MainContent;
